export const productSeo = {
  "678627a1885de812ba69cacb": {
    title: "BHEEM 2.O – Best Survey and Inspection Drone in India",
    description:
      "Buy BHEEM 2.O best survey and inspection drone online in India. Ideal for industrial operations, real-time video monitoring at Drone Planet.",
    canonical:
      "https://api.droneplanet.in/product-detail/678627a1885de812ba69cacb",

    schema: {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: "BHEEM 2.O",
      image:
        "https://drone-planet-prod-bucket.s3.ap-south-1.amazonaws.com/WhatsApp-Image-2025-01-13-at-12.33-12.jpg",
      description:
        "This versatile drone offers excellent performance for a range of industrial and commercial applications.",
      offers: {
        "@type": "Offer",
        url: "https://api.droneplanet.in/product-detail/678627a1885de812ba69cacb",
        priceCurrency: "INR",
        price: "620000",
      },
    },
  },

  "6784b52a885de812ba69c46f": {
    title: "HAWK 3.0 – Buy Best Photography Drone in India",
    description:
      "Buy HAWK 3.0 top photography drone online in India. Capture stunning aerial footage, survey landscapes with power and precision only at Drone Planet.",
    canonical:
      "https://api.droneplanet.in/product-detail/6784b52a885de812ba69c46f",

    schema: {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: "HAWK 3.0",
      image:
        "https://drone-planet-prod-bucket.s3.ap-south-1.amazonaws.com/WhatsApp%20Image%202025-01-13%20at%2011.59.44%20AM.jpeg",
      description:
        "Introducing the Hawk 3.0 Drone – the ultimate combination of power, precision, and performance.",
      offers: {
        "@type": "Offer",
        url: "https://api.droneplanet.in/product-detail/6784b52a885de812ba69c46f",
        priceCurrency: "INR",
        price: "14999",
      },
    },
  },

  "67876cb3885de812ba69d198": {
    title: "DRISHYAK – Best Compact Aerial Photography Drone India",
    description:
      "DRISHYAK best compact aerial photography drone in India. Buy at Drone Planet for aerial footage, landscape surveying and real-time video monitoring.",
    canonical:
      "https://api.droneplanet.in/product-detail/67876cb3885de812ba69d198",

    schema: {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: "DRISHYAK",
      image:
        "https://drone-planet-prod-bucket.s3.ap-south-1.amazonaws.com/WhatsApp-Image-2025-01-13-at-12.33-8%20%289%29.jpg",
      description:
        "Compact drone with 2 kg load capacity and 40-minute flight time for efficient aerial operations.",
      offers: {
        "@type": "Offer",
        url: "https://api.droneplanet.in/product-detail/67876cb3885de812ba69d198",
        priceCurrency: "INR",
        price: "390000",
      },
    },
  },

  "6784b9b9885de812ba69c4f4": {
    title: "HAWK 3.1 – Best Professional Photography Drone India",
    description:
      "HAWK 3.1 best professional aerial photography drone in India. Buy at Drone Planet for aerial footage, landscape surveying and innovative drone experience.",
    canonical:
      "https://api.droneplanet.in/product-detail/6784b9b9885de812ba69c4f4",

    schema: {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: "HAWK 3.1",
      image:
        "https://drone-planet-prod-bucket.s3.ap-south-1.amazonaws.com/WhatsApp-Image-2025-01-13-at-12.33-11.jpg",
      description:
        "Professional aerial photography drone with high-end performance and precision.",
      offers: {
        "@type": "Offer",
        url: "https://api.droneplanet.in/product-detail/6784b9b9885de812ba69c4f4",
        priceCurrency: "INR",
        price: "500000",
      },
    },
  },

  "67f8e247cdca913231aee344": {
    title: "Surya Shakti 15L – Best Kisaan Agriculture Drone India",
    description:
      "Surya Shakti 15L is India's best kisaan drone for farming. Buy DGCA certified autonomous agriculture spraying drone for smart farming at Drone Planet.",
    canonical:
      "https://api.droneplanet.in/product-detail/67f8e247cdca913231aee344",

    schema: {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: "Surya Shakti 15L",
      image:
        "https://drone-planet-prod-bucket.s3.ap-south-1.amazonaws.com/WhatsApp%20Image%202025-04-11%20at%202.14.11%20AM.jpeg",
      description:
        "Fully autonomous agricultural spraying drone designed for smart farming and increased productivity.",
      offers: {
        "@type": "Offer",
        url: "https://api.droneplanet.in/product-detail/67f8e247cdca913231aee344",
        priceCurrency: "INR",
        price: "650000",
      },
    },
  },

  "6784d8c1885de812ba69c722": {
    title: "VIRAJ 1.O – Best Heavy Lifting Agriculture Drone India",
    description:
      "Buy VIRAJ 1.O best heavy lifting agriculture drone in India at Drone Planet. Ideal for powerful farming operations, medium payload and agricultural needs.",
    canonical:
      "https://api.droneplanet.in/product-detail/6784d8c1885de812ba69c722",

    schema: {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: "VIRAJ 1.O",
      image:
        "https://drone-planet-prod-bucket.s3.ap-south-1.amazonaws.com/WhatsApp-Image-2025-01-13-at-12.33-9.jpg",
      description:
        "Powerful agricultural drone with 10 kg load capacity for farming operations.",
      offers: {
        "@type": "Offer",
        url: "https://api.droneplanet.in/product-detail/6784d8c1885de812ba69c722",
        priceCurrency: "INR",
        price: "699999.99",
      },
    },
  },

  "6784b817885de812ba69c4b2": {
    title: "VIRAJ 2.0 – Best Heavy Duty Agriculture Drone India",
    description:
      "VIRAJ 2.0 best heavy duty agriculture drone in India. Ideal for equipment transport, industrial inspections and extended farming operations at Drone Planet.",
    canonical:
      "https://api.droneplanet.in/product-detail/6784b817885de812ba69c4b2",

    schema: {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: "VIRAJ 2.0",
      image:
        "https://drone-planet-prod-bucket.s3.ap-south-1.amazonaws.com/WhatsApp-Image-2025-01-13-at-12.33-4.jpg",
      description:
        "High-performance heavy-duty drone with 16 kg load capacity and 40-minute flight time.",
      offers: {
        "@type": "Offer",
        url: "https://api.droneplanet.in/product-detail/6784b817885de812ba69c4b2",
        priceCurrency: "INR",
        price: "499999",
      },
    },
  },

  "67874e15885de812ba69cf26": {
    title: "BHEEM 1.0 – Best Industrial Heavy Payload Drone India",
    description:
      "BHEEM 1.0 best heavy cargo agriculture drone for industrial and professional use in India. Buy at Drone Planet for long range transport and operations.",
    canonical:
      "https://api.droneplanet.in/product-detail/67874e15885de812ba69cf26",

    schema: {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: "BHEEM 1.0",
      image:
        "https://drone-planet-prod-bucket.s3.ap-south-1.amazonaws.com/WhatsApp-Image-2025-01-13-at-12.33-3%20%281%29.jpg",
      description:
        "Industrial heavy payload drone with 50 kg capacity and 10 km operational range.",
      offers: {
        "@type": "Offer",
        url: "https://api.droneplanet.in/product-detail/67874e15885de812ba69cf26",
        priceCurrency: "INR",
        price: "799000",
      },
    },
  },

  "68565488f0026ea80cf0ed0a": {
    title: "Avispray 16 – Best Crop Spraying Drone in India",
    description:
      "Avispray 16 best indigenous crop spraying drone in India. Buy at Drone Planet for modern farming with cost effectiveness, reliability and high profitability.",
    canonical:
      "https://api.droneplanet.in/product-detail/68565488f0026ea80cf0ed0a",

    schema: {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: "Avispray 16",
      image:
        "https://drone-planet-prod-bucket.s3.ap-south-1.amazonaws.com/AviSpray-16.jpg",
      description:
        "Indigenous 16-litre agricultural spraying drone designed for modern farming applications.",
      offers: {
        "@type": "Offer",
        url: "https://api.droneplanet.in/product-detail/68565488f0026ea80cf0ed0a",
        priceCurrency: "INR",
        price: "720000",
      },
    },
  },
};